import React, { useState } from 'react';
import { resendVerificationNotification } from '../api/auth';

const ResendVerification = ({ token }) => {
  const [resendStatus, setResendStatus] = useState('');
  const [loading, setLoading] = useState(false); // ボタン連打防止用

  if (!token) return null;

  const handleResend = async () => {
    if (loading) return;

    setLoading(true);
    setResendStatus('');

    try {
      const response = await resendVerificationNotification(token);
      setResendStatus(response?.message || '確認メールを再送信しました。ご確認ください。');
    } catch (error) {
      setResendStatus(error?.response?.data?.message || 'メールの再送信に失敗しました。');
    } finally {
      // 最低でも10秒間はボタンを押せないようにする
      setTimeout(() => {
        setLoading(false);
      }, 10000);
    }
  };

  return (
    <div style={{padding: '10px', marginBottom: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button onClick={handleResend} disabled={loading}>
          {loading ? '送信中...' : '認証メールを再送する'}
        </button>
      </div>
      {resendStatus && <p style={{ marginTop: '10px' }}>{resendStatus}</p>}
    </div>
  );
};

export default ResendVerification;
